/*
 * @Author: xiaolong.xu
 * @Date: 2023-03-20 15:36:20
 * @LastEditors: 最后编辑
 * @LastEditTime: 2023-03-20 16:15:10
 * @Description: file content
 */
import { useRouter } from 'next/router'
import { useMemo } from 'react'

const useFbe = () => {
  const router = useRouter()
  const language: 'zh-cn' | 'en' = useMemo(
    () => (router.pathname === '/template' ? 'en' : 'zh-cn'),
    [router],
  )
  const isFbe = useMemo(() => router.pathname === '/template', [router])
  return {
    isFbe,
    language,
  }
}

export default useFbe
